import type { MailboxInfo } from 'owa-client-types';
import { isUnifiedInboxMailboxInfo } from 'owa-client-types/lib/UnifiedInboxMailboxInfo';
import type TableView from '../../store/schema/TableView';

/**
 * For a unified inbox selection, returns true when there is a real (non virtual select-all) row
 * selection that can be fanned out per mailbox.
 *
 * Unlike areSelectedRowKeysFromSameMailboxInfoIfUnifiedInbox this does NOT require all rows to be
 * from the same mailbox: multi-mailbox triage actions (e.g. Flag/Unflag) fan out per mailbox.
 *
 * Returns true for non-unified-inbox tables, and false in virtual select-all mode or with no
 * selection.
 *
 * @param defaultMailboxInfo the table's mailbox info (the synthetic UnifiedInbox mailbox in UIB)
 * @param tableView the table view holding the current selection
 */
export function hasRealSelectionIfUnifiedInbox(
    defaultMailboxInfo: MailboxInfo,
    tableView: TableView
): boolean {
    if (!isUnifiedInboxMailboxInfo(defaultMailboxInfo)) {
        return true;
    }

    // In virtual select-all mode or with no selection, the selected mailboxes can't be enumerated.
    const rowKeys = [...tableView.selectedRowKeys.keys()];
    return !tableView.isInVirtualSelectAllMode && rowKeys.length >= 1;
}
